import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { applyTenantTheme, loadBrandFromEnv } from './shared/tenantTheme';
import { configureTerms, loadTermsFromEnv } from './shared/terms';
import { configureOrg, loadOrgFromEnv, orgTitle } from './shared/org';

// Apply this tenant's brand, terminology and identity overrides before first
// paint. With none of REACT_APP_BRAND_JSON / REACT_APP_TERMS_JSON /
// REACT_APP_ORG_JSON set, all three are no-ops and the app renders with the
// built-in look, wording and name.
applyTenantTheme(loadBrandFromEnv());
configureTerms(loadTermsFromEnv());
configureOrg(loadOrgFromEnv());

// public/index.html ships a neutral title so the tab is never wrong for a
// tenant before the bundle loads; the real one is set here, once org config is
// in hand.
document.title = orgTitle();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
